import { JobStudentMatchingPageComponent } from './job-student-matching-page/job-student-matching-page.component';
import { StudentJobMatchingPageComponent } from './student-job-matching-page/student-job-matching-page.component';

export * from './job-student-matching-page/job-student-matching-page.component';
export * from './student-job-matching-page/student-job-matching-page.component';

export const MATCHING_PAGES = [JobStudentMatchingPageComponent, StudentJobMatchingPageComponent];
